import { render, staticRenderFns } from "./SkupDodatniSadrzajEdit.vue?vue&type=template&id=74dea292&scoped=true&"
import script from "./SkupDodatniSadrzajEdit.vue?vue&type=script&lang=js&"
export * from "./SkupDodatniSadrzajEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dea292",
  null
  
)

export default component.exports